import { Box, Typography, Container, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Logo from "./Logo";
import themeColors from "../theme";

export default function Footer() {
    const { teal } = themeColors;

    return (
        <Box
            sx={{
                backgroundColor: "white",
                borderTop: "1px solid #e0e0e0",
                py: 4,
                mt: "auto",
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                    <Logo size={40} clickable={false} />
                    <Typography variant="body2" sx={{ mt: 2, mb: 1, fontWeight: 500 }}>
                        © {new Date().getFullYear()} OnCallCME. All rights reserved.
                    </Typography>
                    <Box sx={{ display: "flex", gap: 3, justifyContent: "center" }}>
                        <Link
                            component={RouterLink}
                            to="/privacy-policy"
                            underline="hover"
                            sx={{ color: teal, fontSize: "0.95rem", cursor: "pointer" }}
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            component={RouterLink}
                            to="/terms-of-use"
                            underline="hover"
                            sx={{ color: teal, fontSize: "0.95rem", cursor: "pointer" }}
                        >
                            Terms of Use
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}
